"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require("../AbstractReactComponent");

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require("reactstrap");

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _SouborApi = require("../api/gen/dokumenty/SouborApi");

var _SouborApi2 = _interopRequireDefault(_SouborApi);

var _DokumentSoubor = require("../api/gen/proxioapi/decls/DokumentSoubor");

var _DokumentSoubor2 = _interopRequireDefault(_DokumentSoubor);

var _FixedDropDownButton = require("../fixed-dropdown-button/FixedDropDownButton");

var _FixedDropDownButton2 = _interopRequireDefault(_FixedDropDownButton);

var _ActionsRow = require("../detail/ActionsRow");

var _ActionsRow2 = _interopRequireDefault(_ActionsRow);

var _FAIcon = require("../icon/FAIcon");

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _modal = require("../modal");

var modal = _interopRequireWildcard(_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SouborLink = function (_AbstractReactCompone) {
    (0, _inherits3.default)(SouborLink, _AbstractReactCompone);

    function SouborLink() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SouborLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SouborLink.__proto__ || (0, _getPrototypeOf2.default)(SouborLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleSmazatSoubor = function () {
            var soubor = _this.props.soubor;

            _this.dispatch(modal.ModalActions.showConfirm("Smazání přílohy", "Opravdu chcete smazat přílohu?", function () {
                _SouborApi2.default.deleteDokumentSoubor(soubor.id);
            }, null, "Smazat"));
        }, _this.renderActions = function () {
            return _react2.default.createElement(
                _FixedDropDownButton2.default,
                { color: "action", noCaret: true, id: "soubor-actions-dropdown", title: _react2.default.createElement(_FAIcon2.default, { icon: "ellipsis-v" }) },
                _react2.default.createElement(
                    _reactstrap.DropdownItem,
                    { type: "button", key: "1", onClick: _this.handleSmazatSoubor },
                    "Smazat"
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SouborLink, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                soubor = _props.soubor,
                onClick = _props.onClick,
                hlavni = _props.hlavni;


            return _react2.default.createElement(
                _ActionsRow2.default,
                { actions: this.renderActions() },
                _react2.default.createElement(
                    "a",
                    { href: "#", onClick: onClick },
                    hlavni ? _react2.default.createElement(
                        "strong",
                        null,
                        soubor.jmenoSoubor
                    ) : soubor.jmenoSoubor
                )
            );
        }
    }]);
    return SouborLink;
}(_AbstractReactComponent2.default); /**
                                      * Třída slouží k vytvoření klikatelného odkazu k otevření souboru dokumentu.
                                      *
                                      * Použití:
                                      * <SouborLink onClick={handleOnClick} soubor={soubor} hlavni={hlavni} />
                                      */


SouborLink.formName = 'souborLink';
SouborLink.propTypes = {
    onClick: _react2.default.PropTypes.func.isRequired,
    soubor: _react2.default.PropTypes.instanceOf(_DokumentSoubor2.default).isRequired,
    hlavni: _react2.default.PropTypes.bool
};
SouborLink.defaultProps = {
    hlavni: false
};


var reduxFormObj = (0, _reduxForm.reduxForm)({
    form: SouborLink.formName
})(SouborLink);

exports.default = (0, _reactRedux.connect)()(reduxFormObj);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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